// extracted by mini-css-extract-plugin
export default {"container":"Services_container__1aoeh","content":"Services_content__hPUkc"};